import type { LocalDatabase } from '../core/types';

// No mutations currently used for SportActivity
export const SportActivityMutations = {
  // Placeholder for future mutations
};
